import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Entity } from 'src/app/core/models/entity.model';
import { GazeMap, GazeMapErgo } from 'src/app/core/models/gaze-map';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FileSpecsService } from 'src/app/core/services/file-specs.service';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hbo-corridor-modal',
  templateUrl: './corridor-modal.component.html',
  styleUrls: ['./corridor-modal.component.scss']
})
export class CorridorModalComponent implements OnChanges {

  @Input() id?: string | number;
  @Output() confirm = new EventEmitter();

  @Input() entity!: Entity | null;
  @Input() img!: string;
  @Input() gazeMap!: GazeMap;

  @Input() calculated!: string;
  @Input() ergoData!: GazeMapErgo;

  @Input('action') action!: { refresh: boolean };

  vertexDistanceLstnr: Subscription = new Subscription;
  pantoscipicAngleLstnr: Subscription = new Subscription

  constructor(
    private formBuilder: FormBuilder,
    private gazeMapService: GazeMapService,
    private loadingService: LoadingService,
    private fileSpecsService: FileSpecsService
  ) {
    // Suscribirse a cambios de valor para validar en tiempo real
    this.settingsHallwayHeight.controls.vertexDistance.valueChanges.subscribe(() => {
      this.validateNumericField('vertexDistance');
    });
    this.settingsHallwayHeight.controls.pantoscipicAngle.valueChanges.subscribe(() => {
      this.validateNumericField('pantoscipicAngle');
    });
  }

  /**
   * Valida un campo numérico usando las especificaciones del servicio
   */
  private validateNumericField(fieldName: 'vertexDistance' | 'pantoscipicAngle'): void {
    const control = this.settingsHallwayHeight.controls[fieldName];
    const spec = this.fileSpecsService.getSpec(fieldName);
    
    if (!spec || control.value === null || control.value === undefined) {
      return;
    }

    const value = control.value;
    const errors: { [key: string]: any } = {};

    // Validar rango
    if (spec.min !== undefined && value < spec.min) {
      errors['rangeError'] = `El valor debe estar entre ${spec.min} y ${spec.max}`;
    }
    if (spec.max !== undefined && value > spec.max) {
      errors['rangeError'] = `El valor debe estar entre ${spec.min} y ${spec.max}`;
    }

    // Aplicar o limpiar errores
    if (Object.keys(errors).length > 0) {
      control.setErrors({ ...control.errors, ...errors });
    } else {
      // Eliminar solo el error de rango si existe
      if (control.errors) {
        const { rangeError, ...otherErrors } = control.errors;
        control.setErrors(Object.keys(otherErrors).length > 0 ? otherErrors : null);
      }
    }
  }

  hallwayHeight: FormControl<number | null> = new FormControl(null);

  /*settingsHallwayHeight = this.formBuilder.nonNullable.group({
    entityId: 1,
    vertexDistance: [12, Validators.min(5), Validators.max(2)],
    pantoscipicAngle: [10, Validators.min(-5), Validators.max(25)],
    hallwayHeight: this.hallwayHeight
  });*/

  settingsHallwayHeight = this.formBuilder.nonNullable.group({
    entityId: 1,
    vertexDistance: [12, Validators.required],
    pantoscipicAngle: [10, Validators.required],
    hallwayHeight: this.hallwayHeight
  });

  ngOnDestroy() {
    this.vertexDistanceLstnr.unsubscribe();
    this.pantoscipicAngleLstnr.unsubscribe();
  }

  ngOnChanges(_simpleChange: SimpleChanges) {
    console.log(_simpleChange)
    if (_simpleChange)
      (this.settingsHallwayHeight.controls.vertexDistance.patchValue(12),
        this.settingsHallwayHeight.controls.pantoscipicAngle.patchValue(10))
  }

  calculate() {
    // Marcar todos los campos como touched para mostrar errores
    Object.keys(this.settingsHallwayHeight.controls).forEach(key => {
      this.settingsHallwayHeight.get(key)?.markAsTouched();
    });

    // Verificar si el formulario es válido
    if (!this.settingsHallwayHeight.valid) {
      return;
    }

    this.ergoData.panto = this.settingsHallwayHeight.controls.pantoscipicAngle.value;
    this.ergoData.bvd = this.settingsHallwayHeight.controls.vertexDistance.value;
    this.gazeMapService.calculateErgo(this.ergoData).subscribe(response => {
      this.loadingService.startLoading();
      this.action.refresh = false;
      this.settingsHallwayHeight.controls.hallwayHeight.patchValue(Number(Math.min.apply(Math, response.ergo.ergopath).toFixed(1).replace(",", ".")));
    });
  }

}
